import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signInWithPopup,
} from "firebase/auth";
import { auth, googleProvider } from "../../services/firebase";
import GoogleGIcon from '../GoogleGIcon'
import { Button, Form, Container, Alert, Spinner } from "react-bootstrap";
import '../../styles/Auth.css';
import SimpleAuthNavbar from '../SimpleAuthNavbar'

function RegisterPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [registerError, setRegisterError] = useState(null);
  const [isRegistering, setIsRegistering] = useState(false);
  const [isGoogleSigningIn, setIsGoogleSigningIn] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setRegisterError(null);

    if (password !== confirmPassword) {
      setRegisterError("Passwords do not match.");
      return;
    }

    setIsRegistering(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await sendEmailVerification(user);
      alert("Registration successful! Please check your email to verify your account.");
      navigate("/home");
    } catch (error) {
      console.error("Registration error:", error);
      switch (error.code) {
        case "auth/email-already-in-use":
          setRegisterError("This email is already in use.");
          break;
        case "auth/invalid-email":
          setRegisterError("Invalid email address.");
          break;
        case "auth/weak-password":
          setRegisterError("Password should be at least 6 characters.");
          break;
        default:
          setRegisterError("Registration failed. Please try again.");
      }
    } finally {
      setIsRegistering(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setRegisterError(null);
    setIsGoogleSigningIn(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      alert(`Welcome ${result.user.displayName || "back"}!`);
      navigate("/home");
    } catch (error) {
      console.error("Google Sign-In Error:", error);
      setRegisterError("Google Sign-In failed. Please try again.");
    } finally {
      setIsGoogleSigningIn(false);
    }
  };

  return (
    <>
      <SimpleAuthNavbar />
      <Container style={{ maxWidth: "500px" }} className="mt-4">
        <h2 className="text-center mb-4">Register</h2>

        {registerError && (
          <Alert variant="danger" role="alert" aria-live="assertive">
            {registerError}
          </Alert>
        )}

        {/* Custom Form */}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formConfirmPassword">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Confirm your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="w-100"
            disabled={isRegistering || isGoogleSigningIn}
            aria-disabled={isRegistering || isGoogleSigningIn}
          >
            {isRegistering && <Spinner as="span" size="sm" className="me-2" />}
            Register
          </Button>

          <div className="text-center mt-3">
            <Link to="/auth/login">Already have an account? Log in</Link>
          </div>
        </Form>

        {/* Horizontal Divider (always visible) */}
        <div className="divider my-4">
          <span>OR</span>
        </div>

        {/* Google Sign-In Button */}
        <button
          type="button"
          className="google-btn w-100"
          onClick={handleGoogleSignIn}
          disabled={isGoogleSigningIn || isRegistering}
          aria-disabled={isGoogleSigningIn || isRegistering}
          aria-label="Sign in with Google"
        >
          {isGoogleSigningIn ? (
            <>
              <Spinner as="span" size="sm" className="me-2" /> Signing in…
            </>
          ) : (
            <>
              <GoogleGIcon className="google-icon" />
              <span>Sign in with Google</span>
            </>
          )}
        </button>


      </Container>
    </>
  );
}


export default RegisterPage;